import {ImageOptimizerReport} from "./image-optimizer-data-report";
import {Utils} from "../../../../shared/utils/utils";

export class ImageOptimizerReportDataMapper {
  public static map(data: any) {
      const imageOptimizerReportData: ImageOptimizerReport = new ImageOptimizerReport();
      imageOptimizerReportData.id = data.id;
      imageOptimizerReportData.originalSize = data.orig_size;
      imageOptimizerReportData.imageSize = data.image_size;
      imageOptimizerReportData.reduced = data.reduced;
      imageOptimizerReportData.reducedPercent = data.reduced_percent;
      imageOptimizerReportData.url = data.url;
      imageOptimizerReportData.date = Utils.getDate(data.date);
      imageOptimizerReportData.name = data.name;
      return imageOptimizerReportData;
  }

}
